import React from 'react';
import { View, Text } from 'react-native';
import Pending from '@assets/svg/Earnings/Pending';
import Processing from '@assets/svg/Earnings/Processing';
import Success from '@assets/svg/Earnings/Success';
import Wait from '@assets/svg/Earnings/Wait';
import { EarningsStatus } from '../types';
import { ScaledSheet } from '@utils/scale';

interface EarningsCardProps {
  reconSummary: {
    is_recon_completed: boolean;
    date: string;
    date_txt: string;
    total_earnings: number;
    total_earnings_txt: string;
    info_icon: string;
    info_txt: string;
    info_subtext: string;
    show_payout_warning: boolean;
    payout_warning: string;
    payout_warning_cta_txt: string;
  };
}

/**
 * Renders the appropriate icon based on info_icon value
 */
const renderStatusIcon = (iconType: string) => {
  const iconSize = { width: 16, height: 16 };
  
  switch (iconType) {
    case 'PENDING':
      return <Pending {...iconSize} />;
    case 'PROCESSING':
      return <Processing {...iconSize} />;
    case 'SUCCESS':
      return <Success {...iconSize} />;
    case 'WAIT':
      return <Wait {...iconSize} />;
    default:
      return null;
  }
};

/**
 * EarningsCard Component
 * Displays total earnings amount and status
 */
const EarningsCard: React.FC<EarningsCardProps> = ({
  reconSummary = {
    is_recon_completed: false,
    date: '',
    date_txt: '',
    total_earnings: 0,
    total_earnings_txt: '',
    info_icon: '',
    info_txt: '',
    info_subtext: '',
    show_payout_warning: false,
    payout_warning: '',
    payout_warning_cta_txt: '',
  }
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.amount}>{`${reconSummary.total_earnings_txt}`}</Text>
      {reconSummary && (
        <View>
          <View
            style={[styles.statusContainer]}
          >
            <View
              style={[styles.iconContainer]}
            >
              {renderStatusIcon(reconSummary.info_icon)}
              <Text style={[styles.statusText]}>
                {reconSummary.info_txt}
              </Text>
            </View>
          </View>
          {reconSummary.info_subtext ? <View
            style={[styles.subStatusContainer]}
          >
            <Text style={[styles.subStatusText]}>
              {reconSummary.info_subtext}
            </Text>
          </View> : null}
        </View>
      )}
    </View>
  );
};

const styles = ScaledSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 0,
  },
  amount: {
    fontSize: 48,
    fontWeight: '700',
    color: '#000000',
    marginBottom: 8,
  },
  statusContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    borderRadius: 20,
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  iconText: {
    fontSize: 12,
  },
  statusText: {
    fontSize: 14,
    fontWeight: '400',
    paddingHorizontal: 4,
  },
  subStatusContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  subStatusText: {
    fontSize: 10,
    fontWeight: '200',
  }
});

export default EarningsCard;


